import { motion } from "framer-motion";
import { Scissors, Star } from "lucide-react";

const PHRASES = [
  "SHARP CUTS",
  "CLEAN LINES",
  "LANCASTER'S FINEST",
  "ONE CHAIR",
  "NO SHORTCUTS",
  "5.0 RATED",
];

export const Marquee = () => {
  return (
    <section className="relative border-y border-[#27272A] bg-[#0A0A0A] py-10 overflow-hidden">
      <motion.div
        className="flex gap-16 whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 32, repeat: Infinity, ease: "linear" }}
      >
        {[...PHRASES, ...PHRASES, ...PHRASES].map((p, i) => (
          <div key={i} className="flex items-center gap-16 shrink-0">
            <span className="font-display text-5xl md:text-7xl text-white tracking-wide">{p}</span>
            <span className="text-accent">
              {i % 3 === 0 ? <Scissors size={28} /> : <Star size={28} className="fill-accent" />}
            </span>
          </div>
        ))}
      </motion.div>
    </section>
  );
};
